import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/lib/cart";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import StoreSection from "@/components/StoreSection";
import WaysSection from "@/components/WaysSection";
import BlogSection from "@/components/BlogSection";
import CTABand from "@/components/CTABand";
import Footer from "@/components/Footer";
import ServicePage from "@/components/ServicePage";
import StorePage from "@/components/StorePage";
import BookPage from "@/components/BookPage";
import AdminPage from "@/components/AdminPage";
import TestimonialsPage from "@/components/TestimonialsPage";
import AboutPage from "@/components/AboutPage";
import PrivacyPage from "@/components/PrivacyPage";
import FindService from "@/components/FindService";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppButton from "@/components/WhatsAppButton";

const Home = ({ onOpenSearch }) => (
  <>
    <Navbar onOpenSearch={onOpenSearch} />
    <main>
      <Hero onOpenSearch={onOpenSearch} />
      <Marquee />
      <Services />
      <StoreSection />
      <WaysSection />
      <BlogSection />
      <CTABand />
    </main>
    <Footer />
  </>
);

function App() {
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#FAF5EC] min-h-screen text-[#2C221E] font-jakarta">
      <div className="grain-overlay" />
      <Toaster position="top-center" richColors />
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home onOpenSearch={() => setSearchOpen(true)} />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/store" element={<StorePage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
          <FindService open={searchOpen} onClose={() => setSearchOpen(false)} />
          <CartDrawer />
        </BrowserRouter>
      </CartProvider>
      <WhatsAppButton />
    </div>
  );
}

export default App;
